import { Link } from "react-router-dom";

const ProfilePage = () => {
  return (
    <div className="ProfilePage-Container">
      <div className="InfoProfile-Container">
        <img src="http://via.placeholder.com/300" alt="fotoProfile" />
        <div className="InfoProfile-userProfile">
          <div className="InfoProfile-nama">
            <h1>Nama Pengguna</h1>
            <h2>Pangkat Pengguna</h2>
          </div>

          <div className="aboutDanPerusahaan">
            <div className="InfoProfile-about">
              <h4>About</h4>
              <h3>Email</h3>
              <p>EmailPengguna@gmail.com</p>
              <h3>Phone</h3>
              <p>Nomor Telp Pengguna</p>
            </div>

            <div className="Perusahaan">
              <h1 className="perusahaan_judul">Perusahaan</h1>
              <h2>Baso Aci Akang</h2>
              <p>
                Jalan Padjajaran Belakang No.37, 40171, Pasir Kaliki, Cicendo ,
                Bandung
              </p>
            </div>
          </div>
        </div>

        <Link to="/EditProfilePage">
          <button>Edit Profile</button>
        </Link>
      </div>

      <div className="profilePage-namaAnggota">
        <h1>Nama Anggota UMKM</h1>
        <div className="profilePage-AnggotaCard">
          <h2>Nama Anggota 1</h2>
          <p>emailAnggota@gmail.com</p>
        </div>

        <div className="profilePage-AnggotaCard">
          <h2>Nama Anggota 2</h2>
          <p>emailAnggota@gmail.com</p>
        </div>
        <div className="profilePage-AnggotaCard">
          <h2>Nama Anggota 3</h2>
          <p>emailAnggota@gmail.com</p>
        </div>
        <div className="profilePage-AnggotaCard">
          <h2>Nama Anggota 4</h2>
          <p>emailAnggota@gmail.com</p>
        </div>
        <div className="profilePage-AnggotaCard">
          <h2>Nama Anggota 5</h2>
          <p>emailAnggota@gmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
